<div class="emails-type-list">
  <ng-container *ngIf="!loadingSpinner">
    <div class="email-type" *ngFor="let conditionCategory of conditionCategories let i = index">
      <div class="email-type-title">
        {{conditionCategory.title}}

        <!--<i class="pi pi-plus-circle"></i>-->
      </div>
      <div class="email-type-body">
        <div class="email-change-buttons">
          <button mat-button class="email-changer-button"
                  *ngFor="let condition of conditionCategory.conditions; let j = index"
                  (click)="editEmail(condition, i, j)">{{condition.title}}</button>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="loading-body" *ngIf="loadingSpinner">
    <lib-progress-spinner></lib-progress-spinner>
  </div>

</div>
